import { PartnerDetailsType } from '~/campaigns/types/campaign.types'

const DAYS_IN_PERIOD: Record<'monthly' | 'yearly', number> = {
  monthly: 30,
  yearly: 365,
}

const MONTHS_IN_PERIOD: Record<'monthly' | 'yearly', number> = {
  monthly: 1,
  yearly: 12,
}

export const calculatePricePerMonth = (price: number, packageType: 'monthly' | 'yearly'): number => {
  return price / MONTHS_IN_PERIOD[packageType]
}

export const calculatePricePerDay = (price: number, packageType: 'monthly' | 'yearly'): string => {
  return (price / DAYS_IN_PERIOD[packageType]).toFixed(2)
}

export const applyCouponPercentage = (price: number, couponPercentage?: number): number => {
  if (!couponPercentage || couponPercentage <= 0) return price
  const safeCouponPercentage = Math.min(couponPercentage, 100)
  return price * (1 - safeCouponPercentage / 100)
}

export const calculateYearlySavingsPercentage = (
  monthlyPrice: number,
  yearlyPrice: number,
  yearlyCouponPercentage?: number,
): number => {
  const fullMonthlyPerYear = monthlyPrice * 12
  const discountedYearly = applyCouponPercentage(yearlyPrice, yearlyCouponPercentage)

  if (fullMonthlyPerYear <= 0) return 0
  return Math.round(((fullMonthlyPerYear - discountedYearly) / fullMonthlyPerYear) * 100)
}

export const partnerCouponFor = (
  partnerDetails: PartnerDetailsType | undefined,
  interval: 'monthly' | 'yearly',
): string | undefined => partnerDetails?.couponCode?.[interval] || undefined
